var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cgw-header\u003E\u003C\u002Fgw-header\u003E\u003Crouter-outlet\u003E\u003C\u002Frouter-outlet\u003E";;return pug_html;};
module.exports = template;